import React from 'react';
import AddNewPill from '../AddNewPill/AddNewPill';
import styles from '../../GlobalSearch.module.scss';
import { GlobalSearchResult } from '../../useSearchResultFetcher';
import { resolvePrimarySecondaryNames } from '../../../../utils/utils';

type SearchResultsGroupProps = {
    title: string;
    results: GlobalSearchResult[];
    isAddNew?: boolean;
    onSelect: (result: GlobalSearchResult, index: number) => void;
    canArchive?: boolean;
    leadingRow?: React.ReactNode;
};

const SearchResultsGroup = ({ title, results, isAddNew, onSelect, canArchive, leadingRow }: SearchResultsGroupProps) => {
    const items = Array.isArray(results) ? results : [];
    if (items.length === 0 && !leadingRow) return null;

    return (
        <div>
            <h3 className={styles.SearchResultHeading}>{title}</h3>
            {leadingRow}
            {items.map((result, index) => {
                const resultKey = result.orgId || `${title}-${index}`;
                // RECUR-21135 R10/§5: the brand is the primary name (empty-safe fallback to
                // legal); the Registered name (orgName) moves to the right only when the brand
                // is distinct from it AND this isn't an Add New row (AddNewPill renders its own
                // primary, so the brand is never considered there) — otherwise the existing
                // CIN/website secondary is kept.
                const { primary, secondary } = resolvePrimarySecondaryNames(
                    isAddNew ? undefined : result.displayName,
                    result.orgName,
                    result.secondaryMessage || result.websiteUrl,
                );
                return (
                    <div
                        key={resultKey}
                        onMouseDown={(e) => {
                            e.stopPropagation();
                            onSelect(result, index);
                        }}
                        onClick={(e) => e.stopPropagation()}
                        className={`${styles.SearchResultItem} ${isAddNew ? styles.SearchResultItemAddNew : ''}`}
                    >
                        {isAddNew ? (
                            <AddNewPill result={result} />
                        ) : (
                            <span className={styles.OrgNameRow}>
                                <p className={styles.OrgName}>{primary}</p>
                                {result.archived === true && canArchive && <span className={styles.ArchivedBadge}>ARCHIVED</span>}
                            </span>
                        )}
                        <p className={styles.WebsiteUrl}>{secondary}</p>
                    </div>
                );
            })}
        </div>
    );
};

export default SearchResultsGroup;
